<template>
	<div class="flex items-center  flex-row-reverse navbar bg-white p-0 sticky z-50 top-0 left-0 shadow">
		<!-- <div class="w-40 flex items-center">
            <div class="lg:flex pr-2 pl-2.5 cursor-pointer" @click="ontoggle()">
                <img src="@/assets/menu.svg" class="menuIcon cursor-pointer" />
            </div>
            <div class="lg:flex cursor-pointer">
                <span class="text-lg font-bold cursor-pointer">
                    <img src="@/assets/crystalline.svg" alt="" class="crystallineLogo" />
                </span>
            </div>
        </div> -->
		<!-- <div class="flex-1 px-2 mx-2 h-full" @click="closeApps"></div> -->
		 <div class="flex-none">
			<div @click="toggleUserDropdown">
				<img :src="userInfo.picture" class="rounded-full m-1 mr-4 w-8 h-8 cursor-pointer userpicturestyle"  v-if="userInfo.picture"/>
				<div class="m-1 mr-2 w-8 h-8 rounded-full bg-gray text-2xl cursor-pointer" v-else>
					<div class="flex justify-center items-center h-full text-white cursor-pointer">
						{{getUserName()}}
					</div>
				</div>
					<!-- <img src="@/assets/tooltip.svg" alt="" class="w-8 h-8"> -->
				<div v-if="showBlock" class="py-1 bg-white absolute right-4  mt-2.5 shadow card w-80">
					<div class="  py-2 text-gray cursor-pointer flex flex-col items-center" >
						<div v-if="userInfo.picture">
							<img :src="userInfo.picture" class="rounded-full m-1 mr-2 letterIcon cursor-pointer userpicturestyle"  >
						</div>
				<div class="m-1 mr-2 w-12 h-12 rounded-full bg-gray text-2xl cursor-pointer" v-else>
					<div class="flex justify-center items-center h-full text-white cursor-pointer">
						{{getUserName()}}
					</div>
					
				</div>
						<div class="px-4 text-sm text-primary font-semibold mt-2 capitalize" >{{userInfo.name}}</div>
						<div class="px-4 text-xs  text-black mt-1">
						{{userInfo.email}}
					</div>
						<div class=" border-b border-solid border-lightgrey w-full mt-2"></div>
							<p v-if="displayName" class="font-bold text-primary mt-2">{{displayName}}</p>
							<p v-else-if="userInfo.organisationType==10701 && userInfo.domainDisplayName" class="inline-block text-primary font-semibold mt-2 text-sm">{{ userInfo.domainDisplayName }}</p>
							<p v-else class="inline-block text-black font-semibold mt-2 text-sm">Global</p>
							<p class="inline-block text-black text-xs font-semibold mt-1 text-sm">{{ userInfo.roleName }}</p>
							<div class="flex items-center text-black text-xs px-4 mt-1 mb-2">
								Session Expires In: {{ formattedRemainingTime }}
							</div>
							<div class=" border-b border-solid border-lightgrey w-full"></div>
							<div class="flex justify-center items-center mt-2">
								<button class="filterButton flex mt-1 logout" @click="logout()">
								Log Out
								</button>
							</div>
					</div>
				</div>
			</div>
		</div>
		<div class="relative pr-4 pl-2.5 cursor-pointer" @click="showMenuBlock=!showMenuBlock">
			<div class=" cursor-pointer rounded transition-colors duration-200 menubackgroundstyle" :class="showMenuBlock ? 'bg-[#adadad]' : 'hover:bg-lightgrey'" @click="toggleDropdown">
				<img src="@/assets/menuIcon.svg" class="menuIcon" />
			</div>	
			<div v-if="showMenuBlock " class="absolute menucard right-2 bg-white border p-3 flex justify-end flex-wrap gap-5 flex-row-reverse" @click.stop>
				<div v-for="item in items" :key="item.name"  class="selectedAppCard" @click.stop="selectItem(item)">
					<img :src="item.icon" alt="icon" class="icon" />
					<p>{{ item.name }}</p>
				</div>
			</div>	
		</div>
		
	</div>
</template>
<style scoped>
.menubackgroundstyle{
	width: 36px;
    height: 36px;
    border-radius: 32px;
    display: flex;
    align-items: center;
	justify-content: center;
}
.menucard{
	width: 310px;
    border-radius: 10px;
    border-width: 2px;
    margin-top: 12px;
    border-color:var(--color-lightgrey);
 
}
.selectedAppCard {
  background: #fff;
  text-align: center;
  height: 80px;
  width: 80px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;

}

.selectedAppCard:hover {
  background-color: var(--color-lightgrey);
  border-radius: 10px;
}
.icon {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}
.imgBorder{
	border: 1px solid var(--color-lightgrey);
}
.menuIcon{
	width: 24px !important;
	height: 24px !important;
}
.rounded-full:hover{
	box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.1);
}
.navbar{
	min-height: 40px;
	height: 48px;
	 position:fixed;
    width: 100%;
}
.crystallineLogo{
	width:120px;
	margin-top:2px;
}

.right-4{
	box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.08);
}
.letterIcon{
	width: 48px;
	height: 48px;
}
.logout:hover{
	background-color: var(--color-primary);
    border: 1px solid var(--color-primary);
    color: #ffffff;
}
.userpicturestyle{
	border: 1px solid var(--color-lightgrey);
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter,toast } from '../main';
import { mapGetters } from 'vuex';
export default defineComponent({
	computed: {
		...mapGetters({ 
			userInfo: 'userInfo',            
			tenantsInfo:'tenantsInfo'
 		}),
		getlocation() {
			return window.location.origin;
		}
	},
	data() :any{
		return {
			showMenuBlock:false,
			isToggle: true,
			showBlock: false,
			isappsToggle:false,
			displayName:'',
			formattedRemainingTime: 'Loading...', // For displaying remaining time
			timerInterval: null as any,
			warningTime: Number(process.env.VUE_APP_WARNING_TIME) || 1,
			items: [
				{
                    id:10001,
					name: 'Monitor',
					icon: require('@/assets/monitorLogo.svg'),
					url: process.env.VUE_APP_MONITOR_UI,
				},
				{
                    id:10006,
					name: 'DMS',
					icon: require('@/assets/dmsLogo.svg'),
					url: process.env.VUE_APP_DMS_UI,
				},
                {
                    id:10004,
					name: 'Audit',
					icon: require('@/assets/auditLogo.svg'),
					url: process.env.VUE_APP_AUDIT_UI,
				},
                {
                    id:10002,
					name: 'Training',
					icon: require('@/assets/trainingLogo.svg'),
					url: process.env.VUE_APP_TRAINING_UI,
				},
				{   id:10003,
					name: 'Risk',
					icon: require('@/assets/riskLogo.svg'),
					url: process.env.VUE_APP_RISK_UI,
				},
                {
                    id:10007,
					name: 'Planner',
					icon: require('@/assets/plannerLogo.svg'),
					url: process.env.VUE_APP_PLANNER_UI,
				},
			],
		};
	},
	methods: {
		getUserName(){
			return this.userInfo.name.charAt(0).toUpperCase()
		},
		ontoggle() {
			this.isappsToggle = !this.isappsToggle;
			this.showBlock = false
			emitter.emit('apps-sidemenubar', this.isappsToggle);
		},
		triggerNav() {
			window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_MONITOR_UI}`;
		},
		closeApps() {
		 this.showBlock = false
		 this.isappsToggle = false;
		 emitter.emit('apps-sidemenubar', this.isappsToggle);
		},
		
		async logout() {
            var payload = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
                }
            };
            await this.$http
                .post(`${process.env.VUE_APP_AUTH_API}/logout`, payload)
                .then((response: any) => {
                    if (response.status == 200) {
                        toast.success(`Logout Successfully`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                })
                .catch((error: any) => {
                    toast.error(`Save failed with ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
 
            localStorage.removeItem('AUTH_ID');
            window.location.replace(`${process.env.VUE_APP_AUTH_UI}/logout?returnTo=${process.env.VUE_APP_PLANNER_UI}`);
        },
		selectItem(item: any) {
			this.showMenuBlock = false;

			if (item.id === 10007) {
				return;
			}

			const appUi = item.url;
			const session = localStorage.getItem('AUTH_ID');
			const authUi = process.env.VUE_APP_AUTH_UI;

			if (session && appUi) {
				window.location.href = `${appUi}/?session=${encodeURIComponent(session)}`;
				return;
			}

			if (authUi && appUi) {
				const returnTo = encodeURIComponent(appUi);
				const sessionParam = session ? `&session=${encodeURIComponent(session)}` : '';
				window.location.href = `${authUi}/session?returnTo=${returnTo}${sessionParam}`;
			}
		},
		toggleDropdown(event: MouseEvent) {
			event.stopPropagation();
			this.showMenuBlock = !this.showMenuBlock;
			if (this.showBlock==true) {
				 this.showBlock = false;
			}
            
		},
        toggleUserDropdown(){
            if(this.showMenuBlock == true) {
                this.showMenuBlock = false;
            }
             this.showBlock=!this.showBlock
             
        },	
		async getAllTenants() {
			if (!this.tenantsInfo?.length) {
				await this.$store.dispatch('getTenantsInfo');
			}
			this.tenantsInfo.filter((tenant:any) => {
			let userDomain = this.userInfo.email.substring(this.userInfo.email.lastIndexOf("@") + 1);
            let  userOrgDetails = userDomain.split('.')[0];			
			if(tenant.organisationType!=10701 &&  tenant.tenantName!= undefined && userOrgDetails.toLowerCase()==tenant.tenantName.toLowerCase()){
				this.displayName= tenant.displayName
			}
					
				});
		},
		updateRemainingTime() {
			if (!this.userInfo.expires) return;

			const update = () => {
				const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
				const expiresTime = this.userInfo.expires; // Expiration time in seconds
				const remainingTime = expiresTime - currentTime; // Remaining time in seconds

				if (remainingTime <= 0) {
					this.formattedRemainingTime = 'Session Expired';
					emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
					clearInterval(this.timerInterval);
					return;
				}

				// Convert remaining time into hh:mm:ss format
				const hours = Math.floor(remainingTime / 3600);
				const minutes = Math.floor((remainingTime % 3600) / 60);
				const seconds = remainingTime % 60;

				this.formattedRemainingTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
				const [hrs, mins, secs] = this.formattedRemainingTime.split(':').map(Number);
                const totalSeconds = (hrs * 3600) + (mins * 60) + secs;
                const warningTimerSec = Number(this.warningTime) * 60;
                if (Number.isFinite(warningTimerSec) && warningTimerSec > 0 && totalSeconds <= warningTimerSec) {
                    emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
                    emitter.emit('showPopup',true);
 
                }
			};

			update(); // Call once immediately
			this.timerInterval = setInterval(update, 1000); // Update every second
		},
	},

	async mounted() {
		await this.getAllTenants();
		this.updateRemainingTime(); // Start countdown timer
			emitter.on('apps', (isToggle: any) => {
			this.isappsToggle = isToggle;
			this.showBlock = isToggle;
			this.showMenuBlock=isToggle;

		});
		emitter.on('session-extended', (newExpires: any) => {
			this.userInfo.expires = newExpires;
			this.updateRemainingTime();
		});
	},
	beforeUnmount() {
		if (this.timerInterval) {
			clearInterval(this.timerInterval); // Clear interval when component unmounts
		}
	}
});
</script>